/**
 * Presentational: "Locations" heading for the right column.
 * Single Responsibility: render heading only; copy from constants.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { PAGE_COPY } from '../constants';

const HEADING_CLASS =
  'font-[\'Roboto:SemiBold\',sans-serif] font-semibold text-lg mb-6 text-black';
const HEADING_STYLE = { fontVariationSettings: "'wdth' 100" };

export function LocationsColumnHeader({ heading = PAGE_COPY.LOCATIONS_HEADING }) {
  return (
    <h3 className={HEADING_CLASS} style={HEADING_STYLE}>
      {heading}
    </h3>
  );
}

LocationsColumnHeader.propTypes = {
  /** Override heading (defaults to PAGE_COPY.LOCATIONS_HEADING) */
  heading: PropTypes.string,
};
